import { render } from "./SemesterFormModal.vue?vue&type=template&id=25aea103&scoped=true"
import script from "./SemesterFormModal.vue?vue&type=script&lang=js"
export * from "./SemesterFormModal.vue?vue&type=script&lang=js"

import "./SemesterFormModal.vue?vue&type=style&index=0&id=25aea103&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25aea103"]])

export default __exports__